import Head from "next/head";
import { END } from "redux-saga";
import { useSelector } from "react-redux";

import Faq from "../src/faq/Faq";

import { wrapper } from "../src/config/Store";
import { getAllCMS } from "../src/redux/cms/CMSActions";
import constants from "../src/utils/Constants";
import Routes from "../src/routes/Routes";

import { faqsBodySchema } from "../GO-Bermondsey_Schema";

const { CMS_TYPES, CMS_PAGES } = constants;

const Faqs = () => {
  const mPageDetails = useSelector(({ cms }) => {
    const boardKey = JSON.stringify({
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.FAQ,
    });

    const boards = cms.boards;
    const mPageDetailsId = boards[boardKey]?.list?.[0];

    return cms.cmsMap[mPageDetailsId] || {};
  });

  return (
    <>
      <Head>
        <title>{mPageDetails.name}</title>
        <meta name="description" content={mPageDetails.description} />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link rel="canonical" href={`${Routes?.domain}${Routes?.faqs}`} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: faqsBodySchema,
          }}
        />

      </Head>

      <Faq />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const cmsState = store.getState().cms;

    const pageDetailsParams = {
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.FAQ,
    };
    const pageDetailsBoard = cmsState.boards[JSON.stringify(pageDetailsParams)];
    if (!pageDetailsBoard) {
      store.dispatch(getAllCMS(pageDetailsParams));
    }

    const faqsParams = { type: CMS_TYPES.FAQ };
    const faqsBoard = cmsState.boards[JSON.stringify(faqsParams)];
    if (!faqsBoard) {
      store.dispatch(getAllCMS(faqsParams));
    }

    if (!pageDetailsBoard || !faqsBoard) {
      store.dispatch(END);
    }

    await store.sagaTask.toPromise();
  }
);

export default Faqs;
